// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .pilot-test-dialog-panel .mdc-dialog__surface {
  border-radius: 24px !important;
  background: #f6f7fb;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(20, 24, 31, 0.2);
}

:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-content {
  max-height: 95vh;
  padding: 0 24px 10px;
}

:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-title {
  margin-bottom: 0;
}

:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-actions {
  padding: 0 24px 22px;
  margin-bottom: 0;
}

.dialog-title {
  margin: 22px 0 20px;
  color: #23242a;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: -0.02em;
  text-align: center;
}

.dialog-shell {
  display: block;
}

.dialog-form {
  display: block;
}

.content {
  background: #fff;
  border: 1px solid #eceef4;
  padding: 16px 18px 12px;
  margin-bottom: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.field-row-description {
  align-items: flex-start;
}

.field-label {
  flex: 0 0 182px;
  margin: 0;
  color: #40444f;
  line-height: 1.15;
  padding-top: 7px;
}

.field-row-description .field-label {
  padding-top: 9px;
}

.field-value {
  flex: 1 1 auto;
  min-width: 0;
}
.field-value input,
.field-value select,
.field-value textarea {
  width: 100%;
}

.date-pair {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-pair-label {
  flex: 0 0 auto;
  color: #4f5663;
  white-space: nowrap;
  margin: 0;
}

.general-error {
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 0.85em;
  margin: -4px 0 10px;
}

.hpht-section {
  padding: 0 0 1rem;
}

.hpht-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.hpht-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.hpht-row input,
.hpht-row select {
  flex: 1 1 auto;
  min-width: 0;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.dialog-button {
  min-width: 118px;
  height: 48px;
  border: 0;
  border-radius: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0;
  padding: 0 20px;
}

.dialog-button:disabled {
  background: #c2c8d1 !important;
  color: #7a8291;
  opacity: 1;
  cursor: not-allowed;
}

.dialog-button-secondary {
  background: #1465a9;
  cursor: pointer;
}

.dialog-button-primary {
  background: #0d5bb8;
  cursor: pointer;
}

.dialog-button mat-progress-spinner {
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/pilot-test/pilot-test-dialog/pilot-test-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;AACE;;;EAGE,WAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,sDAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAF;AAEE;;EAEE,cAAA;EACA,YAAA;AAAJ;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,8BAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AADF","sourcesContent":[":host ::ng-deep .pilot-test-dialog-panel .mdc-dialog__surface {\n  border-radius: 24px !important;\n  background: #f6f7fb;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(20, 24, 31, 0.2);\n}\n\n:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-content {\n  max-height: 95vh;\n  padding: 0 24px 10px;\n}\n\n:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-title {\n  margin-bottom: 0;\n}\n\n:host ::ng-deep .pilot-test-dialog-panel .mat-mdc-dialog-actions {\n  padding: 0 24px 22px;\n  margin-bottom: 0;\n}\n\n.dialog-title {\n  margin: 22px 0 20px;\n  color: #23242a;\n  font-size: 2rem;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n  text-align: center;\n}\n\n.dialog-shell {\n  display: block;\n}\n\n.dialog-form {\n  display: block;\n}\n\n.content {\n  background: #fff;\n  border: 1px solid #eceef4;\n  padding: 16px 18px 12px;\n  margin-bottom: 1rem;\n}\n\n.field-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.field-row-description {\n  align-items: flex-start;\n}\n\n.field-label {\n  flex: 0 0 182px;\n  margin: 0;\n  color: #40444f;\n  line-height: 1.15;\n  padding-top: 7px;\n}\n\n.field-row-description .field-label {\n  padding-top: 9px;\n}\n\n.field-value {\n  flex: 1 1 auto;\n  min-width: 0;\n\n  input,\n  select,\n  textarea {\n    width: 100%;\n  }\n}\n\n.date-pair {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.date-pair-label {\n  flex: 0 0 auto;\n  color: #4f5663;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.general-error {\n  color: var(--mat-form-field-error-text-color, #f44336);\n  font-size: 0.85em;\n  margin: -4px 0 10px;\n}\n\n.hpht-section {\n  padding: 0 0 1rem;\n}\n\n.hpht-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.hpht-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n\n  input,\n  select {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.dialog-button {\n  min-width: 118px;\n  height: 48px;\n  border: 0;\n  border-radius: 0;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0;\n  padding: 0 20px;\n}\n\n.dialog-button:disabled {\n  background: #c2c8d1 !important;\n  color: #7a8291;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.dialog-button-secondary {\n  background: #1465a9;\n  cursor: pointer;\n}\n\n.dialog-button-primary {\n  background: #0d5bb8;\n  cursor: pointer;\n}\n\n.dialog-button mat-progress-spinner {\n  display: inline-block;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
